// Collabora iframe URL builders. The URL carries ONLY the dedicated WOPI token minted by POST /wopi/token.

import type { WopiToken } from 'services/auth/wopi';

const collaboraBase = (): string => import.meta.env.VITE_API_BASE_URL_COLLABORA || '';

export const templateFileId = (code: string): string => `templates_${code}`;

export const orderFileId = (orderId: string, archiveId: string): string => `${orderId}_${archiveId}`;

export const buildCollaboraUrl = (fileId: string, token: WopiToken): string => (
  `${collaboraBase()}${fileId}&access_token=${encodeURIComponent(token.accessToken)}&access_token_ttl=${token.ttl}`
);

export const withCollaboraDarkTheme = (frameSrc: string): string => `${frameSrc}&darkTheme=true`;

// Origin of the iframe, used as the postMessage target and as the inbound origin check. Null when misconfigured.
export const collaboraOrigin = (): string | null => {
  try {
    return new URL(collaboraBase()).origin;
  } catch {
    return null;
  }
};

export const collaboraAllow = (): string => {
  const domain = collaboraBase().split('/browser')[0];
  return `clipboard-read ${domain}; clipboard-write ${domain}`;
};
